import React from 'react';
import t from 'modules/i18n/intl';
import SectionMessage from '@atlaskit/section-message';
import { styled } from 'styled-components';
import config from 'appconfig';

import { Dimensions } from 'components/visuals';
import { messages } from '../messages';
import { askUsLink } from '../DownloadSourcePage';

const InfoSectionMessageWithMarginRight = styled.div`
  margin-right: ${Dimensions.units(1)}px;
`;

const MACCloudReadModeMessage = () => {
  const description = t(messages.cloudReadModeDescription, {
    askUsLink,
    FAQsLink: (chunks) => (
      <a
        href={`${config.wacPurchaseLicensingUrl}#billing-engine`}
        target="_blank"
        rel="noreferrer"
        title="Billing Engine"
      >
        {chunks}
      </a>
    ),
  });
  return (
    <InfoSectionMessageWithMarginRight>
      <SectionMessage>{description}</SectionMessage>
    </InfoSectionMessageWithMarginRight>
  );
};

export default MACCloudReadModeMessage;
